import { Box, Flex, Text, Link } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";

import CloseIcon from "@components/CloseIcon";
import ModalDrawer from "@components/ModalDrawer";
import { AUDITS_DATA } from "@constants/common";

interface AuditsModalProps {
  isOpen: boolean;
  closeModal(): void;
}

const AuditsModal = ({ isOpen, closeModal }: AuditsModalProps) => {
  return (
    <ModalDrawer
      isOpen={isOpen}
      closeAlert={() => closeModal()}
      contentProps={{
        p: { base: "0rem 1rem 2.5rem", md: "2.5rem 2rem" },
      }}
    >
      <Flex flexDir="column" gap={{ base: "32px", md: "40px" }} w="100%">
        <Flex
          justifyContent="space-between"
          h={{ md: "24px" }}
          flexDir={{ base: "column-reverse", md: "row" }}
        >
          <Text
            w="100%"
            color="textPrimary"
            fontSize={{ base: "20px", md: "24px" }}
            fontWeight="600"
            mt={{ base: "-22px", md: "auto" }}
          >
            Safe and Secure
          </Text>
          <CloseIcon onClose={closeModal} />
        </Flex>

        <Flex
          justifyContent={{ base: "center", md: "space-between" }}
          flexDir={{ base: "column", md: "row" }}
          gap="32px"
          alignItems={{ base: "flex-start" }}
        >
          {AUDITS_DATA.map((data) => (
            <Flex
              flexDir={{ base: "row", md: "column" }}
              key={data.key}
              gap="6px"
              w={{ base: "100%", md: "224px" }}
              justifyContent="space-between"
              alignItems={{ base: "center", md: "flex-start" }}
            >
              <Box width="114px" height="32px" pos="relative">
                <BaseImage
                  src={data.imgLink}
                  alt={data.key}
                  layout="fill"
                  objectFit="contain"
                />
              </Box>

              <Link
                href={`${data.link}`}
                target="_blank"
                rel="noreferrer"
                borderBottom="1px dotted"
                _hover={{
                  textDecor: "none",
                }}
                w="fit-content"
              >
                <Text
                  p="4px 0"
                  fontSize="12px"
                  fontWeight="500"
                  lineHeight="130%"
                >
                  Get full report ↗
                </Text>
              </Link>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </ModalDrawer>
  );
};

export default AuditsModal;
